import { render } from "./ClassManager.vue?vue&type=template&id=0984af60&scoped=true"
import script from "./ClassManager.vue?vue&type=script&lang=js"
export * from "./ClassManager.vue?vue&type=script&lang=js"

import "./ClassManager.css?vue&type=style&index=0&id=0984af60&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0984af60"]])

export default __exports__